import React, { Component } from 'react';
import Header from "../Header/Header"
import Menu from "../Menu/Menu"
import Promo from "../Screens/0_Promo/Promo"
import Robot from "../Screens/1_Robot/Robot"
import Music from "../Screens/2_Music/Music"
import Photo from "../Screens/3_Photo/Photo"
import View from "../Screens/4_View/View"
import Playbuzz from "../Screens/5_Playbuzz/Playbuzz"
import { wheelDragDirection } from "../Services/SwipeEvents"
import Popup from '../Helpers/Popup/Popup';
import Landscape from '../Helpers/Landscape/Landscape';

class Homepage extends Component {
    constructor() {
        super();
        this.setTransform = this.setTransform.bind(this);
        this.menuClicked = this.menuClicked.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
        this.state = {
            isMenuClicked: false,
            transform: 0,
            currentScreen: 0,
            isBusy: false,
            isPopupActive: false,
            popupContext: null,
            popupClass: null
        }
    }
    componentDidMount() {
        this.mainScreen.addEventListener('swu', (event) => this.wrapperScrolling(event));
        this.mainScreen.addEventListener('swd', (event) => this.wrapperScrolling(event));
        this.mainScreen.addEventListener("mousewheel", (event) => this.wrapperScrolling(event));
        this.mainScreen.addEventListener('DOMMouseScroll', (event) => this.wrapperScrolling(event));
        window.setTimeout(() => {
            var _body = window.document.body;
            if (_body.className && _body.className.indexOf("lg-home-screen") < 0) {
                _body.className += " lg-home-screen"
            }
        }, 100)
    }
    menuClicked(state) {
        this.setState({
            isMenuClicked: state
        })
    }
    setTransform(num) {
        this.setState({
            currentScreen: num,
            transform: `translateY(${-window.document.body.clientHeight * num}px)`
        })
    }
    wrapperScrolling(event) {
        if (this.state.isBusy) return;
        this.setState({
            isBusy: true
        }, () => {
            window.setTimeout(() => {
                this.setState({
                    isBusy: false
                })
            }, 800);
        })

        var num = this.state.currentScreen;
        if (wheelDragDirection(event) == "down") {
            num++;
        } else {
            num--;
        }
        num = num < 0 ? 0 : num;
        num = num >= 5 ? 5 : num;
        this.setTransform(num);
    }
    togglePopup(_class, _className) {
        this.setState({
            isPopupActive: !this.state.isPopupActive
        })
        if (_class != "") {
            this.setState({
                popupContext: _class,
                popupClass: _className
            })
        }
    }
    render() {
        return (
            <div>
                <Landscape />
                <Header
                    toggleMenu={this.state.isMenuClicked}
                    currentScreen={this.state.currentScreen}
                    menuClicked={this.menuClicked} />
                <Menu
                    currentScreen={this.state.currentScreen}
                    setTransform={this.setTransform}
                    toggleMenu={this.menuClicked}
                    menuClicked={this.state.isMenuClicked} />
                <main ref={mainScreen => this.mainScreen = mainScreen}>
                    <Popup
                        isActive={this.state.isPopupActive}
                        context={this.state.popupContext}
                        className={this.state.popupClass}
                        togglePopup={this.togglePopup} />
                    {/* <div className="main-wrapper"> */}
                    <div className="main-wrapper" style={{ transform: this.state.transform }}>
                        <Promo
                            setTransform={this.setTransform} />
                        <Robot
                            currentScreen={this.state.currentScreen} />
                        <Music
                            currentScreen={this.state.currentScreen}
                            togglePopup={this.togglePopup} />
                        <Photo
                            currentScreen={this.state.currentScreen}
                            togglePopup={this.togglePopup} />
                        <View
                            currentScreen={this.state.currentScreen} />
                        <Playbuzz
                            togglePopup={this.togglePopup} />
                    </div>
                </main>
            </div>
        );
    }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/Components/App/Homepage.jsx